import { searchListingsViaIntegration } from './api';

/**
 * Run a SearchPage listings.query.
 *
 * When `createdAtStart` is present (legacy Date listed proxy), Marketplace API ignores
 * the param. Always use POST /api/search-listings (Integration SDK stays
 * server-only — never import it from this client-bundled module).
 *
 * Date listed now filters via Marketplace `pub_publishedAt` min range, so this
 * branch is unused for the SearchPage listed filter.
 *
 * @param {Object} marketplaceSdk
 * @param {Object} params
 * @returns {Promise}
 */
export const queryListingsForSearch = (marketplaceSdk, params) => {
  if (!params?.createdAtStart) {
    return marketplaceSdk.listings.query(params);
  }

  return searchListingsViaIntegration(params);
};
